import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import ModalCustom from 'components/common/ModalCustom';
import { PdfPreviewWrapper, PdfIframe, PdfActions } from './styles';

const PreviewPdf = ({ visibleModal, location: locationProp }) => {
  const locationFromHook = useLocation();
  const location = locationProp || locationFromHook;
  const searchParams = new URLSearchParams(location.search);
  const pdfUrl = searchParams.get('url') || searchParams.get('pdfUrl');
  const fileName = searchParams.get('fileName') || 'document.pdf';

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = fileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleOpenInNewTab = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  };

  if (!pdfUrl) {
    return (
      <ModalCustom
        title="PDF Preview"
        open={visibleModal}
        width={800}
        style={{ top: 20 }}
      >
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <p>No PDF URL provided</p>
        </div>
      </ModalCustom>
    );
  }

  return (
    <ModalCustom
      title={fileName}
      open={visibleModal}
      width="90%"
      style={{ top: 20 }}
      bodyStyle={{ padding: 0, height: 'calc(100vh - 120px)' }}
    >
      <PdfPreviewWrapper>
        <PdfActions>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleDownload}
          >
            Download
          </Button>
          <Button onClick={handleOpenInNewTab}>Open in New Tab</Button>
        </PdfActions>
        <PdfIframe
          src={`${pdfUrl}#toolbar=1&navpanes=1&scrollbar=1`}
          title={fileName}
        />
      </PdfPreviewWrapper>
    </ModalCustom>
  );
};

PreviewPdf.propTypes = {
  visibleModal: PropTypes.bool,
  location: PropTypes.object,
};

PreviewPdf.defaultProps = {
  visibleModal: false,
  location: null,
};

export default PreviewPdf;
